import React from 'react'
import random from '../../assets/random_pp.png'
import { Link } from 'react-router-dom'
import styles from './Profile.module.css'

const Profile = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <div className={styles.topHeader}>
                    <Link to="/my-account">
                        <i className={styles.backIcon + " fas fa-chevron-left"}></i>
                    </Link>
                    <h1>My Profile</h1>
                </div>
                <div className={styles.profile}>
                    <img src={random} alt="random-pic" />
                </div>
            </header>

            <main>
                <div className={styles.row}>
                    <h2>Full Name</h2>
                    <p>John Doe</p>
                </div>
                <div className={styles.row}>
                    <h2>Email Address</h2>
                    <p>john@gmail.com</p>
                </div>
                <div className={styles.row}>
                    <h2>Phone Number</h2>
                    <p>0900-786-01</p>
                </div>
            </main>

        </div>
    )
}

export default Profile
